import(/* webpackMode: "eager", webpackExports: ["Background","BackgroundVariant","Dots"] */ "/vercel/path0/node_modules/.pnpm/@xyflow+react@12.5.6_@types+react@18.3.20_react-dom@18.3.1_react@18.3.1/node_modules/@xyflow/react/dist/esm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/canvas/src/components/CanvasLayout/CanvasLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AiPage"] */ "/vercel/path0/packages/canvas/src/pages/AiPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CanvasById"] */ "/vercel/path0/packages/canvas/src/pages/CanvasById.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CanvasListPage"] */ "/vercel/path0/packages/canvas/src/pages/CanvasListPage/CanvasListPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IframeEmbeddedCanvas"] */ "/vercel/path0/packages/canvas/src/pages/IframeEmbeddedCanvas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TemplatePage"] */ "/vercel/path0/packages/canvas/src/pages/TemplatePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewOnlyCanvas"] */ "/vercel/path0/packages/canvas/src/pages/ViewOnlyCanvas.tsx");
